module.exports = __webpack_public_path__ + "img/room.9c3e2040.svg";